import React from "react"
import PropTypes from "prop-types"
import cn from "classnames"
import styles from "./styles.css"

const Tooltip = ({ style, className, children, position }) => {
  const direction =
    position === `top` || position === `bottom` ? `horizontal` : `vertical`

  return (
    <span
      style={style}
      className={cn(
        styles.tooltip,
        styles[position],
        styles[direction],
        className,
      )}
    >
      {children}
    </span>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  position: PropTypes.oneOf([`top`, `right`, `bottom`, `left`]),
  style: PropTypes.shape({}),
}

Tooltip.defaultProps = {
  className: ``,
  position: `bottom`,
  style: {},
}

export default Tooltip
